import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap';
import { NoCommaPipe } from './no-comma.pipe';

@NgModule({
  declarations: [
    NoCommaPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule,
    TranslateModule,
    ModalModule.forRoot()
  ],
  exports: [
    CommonModule,
    FormsModule,
    UIRouterModule,
    TranslateModule,
    ModalModule,
    NoCommaPipe
  ]
})

export class SharedModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/shared/shared.module.ts